var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-iframe',{attrs:{"src":_vm.src,"frame-id":"my-ifram","name":"my-frame","width":"150px","height":"500px"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }